import React, { Fragment } from 'react';
import NavbarHome from '../pages/components/NavbarHome';
import DaftarTerjual from '../pages/DaftarTerjual';

export default function LayoutdDaftarJualDiminati() {
  return (
    <Fragment>
      <NavbarHome />
      <DaftarTerjual />
    </Fragment>
  );
}
